
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class DescriptionListing extends Vue {
  @Prop(String) readonly title!: string;
  @Prop(String) readonly name!: string;
  @Prop(String) readonly type!: string;
  @Prop(Boolean) readonly experience!: boolean;
  @Prop(Boolean) readonly chips!: boolean;
  @Prop({ default: () => [] }) readonly items!: any[];

  get sortedByDates() {
    return this.experience
      ? this.items.sort(
          (a, b) => Date.parse(b.startDate) - Date.parse(a.startDate)
        )
      : this.items.sort((a, b) => b.year - a.year);
  }
}
